import { render, staticRenderFns } from "./MagazineVolumeEditBibliographyInfo.vue?vue&type=template&id=760611a3&"
import script from "./MagazineVolumeEditBibliographyInfo.vue?vue&type=script&lang=ts&"
export * from "./MagazineVolumeEditBibliographyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MagazineVolumeEditBibliographyInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})
